import { useSelector } from 'react-redux';
import TableFunction from '../../../../../components/table/TableFunction';
import CustomTh from '../../../../../components/table/CustomTh';
import React, { useState } from 'react';
import CustomTd from '../../../../../components/table/CustomTd';
import CustomImageTable from '../../../../../components/CustomImageTable';
import BoyAvatar from '../../../../../assets/images/boyAvatarT.svg';
import womanAvatar from '../../../../../assets/images/womanAvatarT.png';
import { EMPLOYEE_ID_REGEX } from '../../../../../utils/EmployeeIdRegex';
import { EMPTY_VALUES, getDateFormat, getFullName } from '../../../../../Apis/functions';
import CustomChip from '../../../../../components/CustomChip';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../../enums/statusColorEnum';
import { status } from '../../../../../enums/statusEnum';
import { permissionObj } from '../../../../../Helpers/permission';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';
import routes from '../../../../../Routes/routes';
import AllEmployeeDataApp from './AllEmployeeDataApp';
import { useNavigate } from 'react-router-dom';
import {
    DetailsIconsOptions,
    IconDocumentation,
    IconPersonPhoto,
    UpdateIconsOptions,
} from '../../../../../components/buttons/IconButtons';
import CustomTooltip from "../../../../../components/CustomTooltip";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param props
 */
const AllEmployeesTableApp = (props) => {

    const {
        contractorId,
        supplierId,
        setIsAllChecked,
        setSimpleSearch,
        searchElement,
        selectedList,
        setSelectedList,

        setExpandImage,
        modified,
        setModified,

        finalArray,
        view,
        setCriteria,
        option,
        setBodyForExport,
        showActionsContractorSupplier
    } = props;

    const navigate = useNavigate();
    const DEV = useSelector((state) => state?.CommonsSlice?.development); // Access development state for conditional rendering
    const { permission } = useSelector((state) => state.authenticatioauthennSlice); // Access user permission data
    const [searchResults, setSearchResults] = useState('');
    const tableId = "tbl_aeta_employees";
    const searchId = "txt_aeta_search_employees";
    const deletePermission = (contractorId !== null || supplierId !== null || DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_DELETE));
    const leftPosition = deletePermission ? 50 : 0;
    const handleIdentityValidationClick = (item) => {
        const userId = item?.userId;

        if (contractorId) {
            navigate(routes.contractor.identityValidation + userId, {
                state: { backUrl: routes.contractor.searchEmployee },
            });
            return;
        }

        if (supplierId) {
            navigate(routes.suppliers.identityValidation + userId, {
                state: { backUrl: routes.suppliers.employees },
            });
            return;
        }

        navigate(routes.employee.identityValidation + userId, {
            state: { backUrl: routes.employee.list },
        });
    };

    const getThead = () => {
        let header = [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes='first_head'>
                {t('name')}
            </CustomTh>,
            <CustomTh tableId={tableId}>{t('email')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('phone_number')}</CustomTh>,
        ];

        if (contractorId === null && supplierId === null) {
            header.push(<CustomTh tableId={tableId}>{t('documentId')}</CustomTh>);
            header.push(<CustomTh tableId={tableId}>{t('work_station')}</CustomTh>);
            header.push(<CustomTh tableId={tableId}>{t('privilege')}</CustomTh>);
            header.push(<CustomTh tableId={tableId}>{t('department')}</CustomTh>);
            header.push(<CustomTh tableId={tableId}>{t('employee_id')}</CustomTh>);
            header.push(<CustomTh tableId={tableId}>{t('ceco')}</CustomTh>);
        } else if (contractorId !== null || supplierId !== null) {
            header.push(<CustomTh tableId={tableId}>{t('dob')}</CustomTh>);
            header.push(<CustomTh tableId={tableId}>{t('documentId')}</CustomTh>);
            header.push(<CustomTh tableId={tableId}>{t('status')}</CustomTh>);
        }
        return header;
    };

    const getTbody = () => {
        if (!searchResults || searchResults?.content?.length === 0) {
            return {
                body: [],
                data: []
            };
        }

        const body = searchResults?.content.map((item, index) => {
            const fullName = item?.fullName || getFullName(item?.name, item?.lastName, item?.secondLastName);
            return (
                <>
                    <CustomTd tableId={tableId} tooltip={fullName} fixed={true} left={leftPosition}
                              classes={'first-column'}>
                        <span className='text-ellipsis'>
                            <CustomImageTable
                                text={fullName}
                                image={
                                    (item?.genderId === 1 && BoyAvatar) ||
                                    (item?.genderId === 2 && womanAvatar) ||
                                    (item?.genderId === null && BoyAvatar)
                                }
                                buttonImg={'btn_aem_expand_image_' + index}
                                click={(e, image) => {
                                    setExpandImage(image);
                                }}
                            />
                        </span>
                    </CustomTd>
                    <CustomTd tableId={tableId}>{item?.email || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId}>{item?.phoneNumber || EMPTY_VALUES.DEFAULT}</CustomTd>

                    {contractorId === null && supplierId === null && (
                        <>
                            <CustomTd tableId={tableId}>{item?.documentId || EMPTY_VALUES.DEFAULT}</CustomTd>
                            <CustomTd tableId={tableId}>{item?.workStation || EMPTY_VALUES.DEFAULT}</CustomTd>
                            <CustomTd tableId={tableId}>{item?.role || EMPTY_VALUES.DEFAULT}</CustomTd>
                            <CustomTd tableId={tableId}>{item?.department || EMPTY_VALUES.DEFAULT}</CustomTd>
                            <CustomTd tableId={tableId}>
                                {item?.employeeId && EMPLOYEE_ID_REGEX.test(item.employeeId)
                                    ? parseInt(item.employeeId, 10)
                                    : item?.employeeId || EMPTY_VALUES.DEFAULT}
                            </CustomTd>
                            <CustomTd tableId={tableId}>
                                {item?.cecoCode ?
                                    <div className={"maxw-200px"}>
                                        <CustomTooltip
                                            text={item?.cecoCode}
                                            classes={"font-color-general-950 text-ellipsis-1-row"}
                                            showIfTruncated={true}
                                            placement={"top"}
                                        />
                                    </div>
                                    : EMPTY_VALUES.DEFAULT
                                }
                            </CustomTd>
                        </>
                    )}
                    {(contractorId !== null || supplierId !== null) && (
                        <>
                            <CustomTd
                                tableId={tableId}>{item.dob ? getDateFormat(item.dob, false) : EMPTY_VALUES.DEFAULT}</CustomTd>
                            <CustomTd tableId={tableId}>{item?.documentId || EMPTY_VALUES.DEFAULT}</CustomTd>
                            <CustomTd tableId={tableId}>
                                <CustomChip
                                    background={statusColor[item?.statusId]}
                                    fontColor={statusFontColor[item?.statusId]}
                                    borderColor={statusBorderColor[item?.statusId]}
                                    legend={t(status[item?.statusId]) || EMPTY_VALUES.DEFAULT}
                                    variant='large'
                                />
                            </CustomTd>
                        </>
                    )}
                </>
            );
        });

        return {
            body,
            data: searchResults?.content,
        };
    };

    const getActionsButtons = (item, index) => {
        const showButtons = ((contractorId || supplierId) && (showActionsContractorSupplier || item?.periodId))
            || DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE);

        return <>
            {(showButtons) ?
                <DropDownMenuProfile
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    menuId={`menu-${item.id}`}
                >
                    {(showActionsContractorSupplier || DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE)) && (
                        <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t("update")}
                            icon={<UpdateIconsOptions/>}
                            click={() => {
                                if (contractorId !== null) navigate(routes.contractor.updateEmployee + `${item?.userId}`);
                                else if (supplierId !== null) navigate(routes.suppliers.updateEmployee + `${item?.userId}`);
                                else navigate(routes.employee.edit + `${item?.userId}`);
                            }}
                        />
                    )}
                    { (showActionsContractorSupplier) &&
                        <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t("details")}
                            icon={<DetailsIconsOptions />}
                            click={() => {
                                if (contractorId) {
                                    navigate(routes.contractor.employeeDetails + `${item?.userId}`,
                                        {state: {backUrl: routes.contractor.searchEmployee,}});
                                }
                                else if (supplierId) {
                                    navigate(routes.suppliers.employeeDetails + `${item?.userId}`,
                                        {state: {backUrl: routes.suppliers.employees,}});
                                }
                            }}
                        />
                    }
                        <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t('validation_identity')}
                            icon={<IconPersonPhoto />}
                            click={() => handleIdentityValidationClick(item)}
                        />
                    {((contractorId || supplierId) && item?.periodId) && (
                        <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t("documentation")}
                            icon={<IconDocumentation />}
                            click={() => {
                                if (contractorId) {
                                    navigate(routes.contractor.employeeDocumentation + `${item?.userId}`,
                                        {state: {backUrl: routes.contractor.searchEmployee,}});
                                }
                                else if (supplierId) {
                                    navigate(routes.suppliers.employeeDocumentation + `${item?.userId}`,
                                        {state: {backUrl: routes.suppliers.employees,}});
                                }
                            }}
                        />
                    )}
                </DropDownMenuProfile>
                : EMPTY_VALUES.DEFAULT
            }
        </>;
    }

    const {
        getData,
        getDataAdvancedSearch
    } = AllEmployeeDataApp({
        modified,
        finalArray,
        view,
        setCriteria,
        contractorId,
        supplierId,
        option,
        searchElement,
        setBodyForExport,
        setSearchResults,
        setSimpleSearch
    })

    const { t, thead, tbody, handleCheckboxChange, handleDeleteAll,
        pagination, page, setPage, rowsPerPage,
        openMenu, handleMenuToggle, handleClose } = TableFunction({
            selectedList,
            setSelectedList,
            data: searchResults,
            getThead,
            getTbody,
            labelRowsPerPage: 'empolyee_per_page',
            hasContainer: true,
            fixedPagination: false,
            setIsAllChecked,
            searchElement,//New
            getData,//New
            modified,//New
            setModified,//New
            getDataAdvancedSearch,//New - apply only with advanced search
            finalArray,//New - apply only with advanced search
        });

    return {
        searchResults, setSearchResults,
        DEV,
        permission,
        tableId,
        searchId,
        t, thead, tbody, handleCheckboxChange, handleDeleteAll,
        pagination, page, setPage, rowsPerPage,
        openMenu, handleMenuToggle, handleClose,
        getActionsButtons,
        deletePermission
    };
};

export default AllEmployeesTableApp
